import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClassesApiServiceService {

  private apiUrl = environment.apiUrl
  constructor(private http: HttpClient) { }

  getClassesList(page?: number, search?: string ): Observable<any> {
    let queryParams = new HttpParams();
    if (page) {
      queryParams = queryParams.append('page', page.toString());
    }
    if (search) {
      queryParams = queryParams.append('search', search);
    }
    return this.http.get(`${this.apiUrl}class/get-all`, { params: queryParams });
  }

  createClass(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}class/create`, data);
  }

  updateClass(id: any, data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}class/update/${id}`, data);
  }

  deleteClass(id: any): Observable<any> {
    return this.http.get(`${this.apiUrl}class/delete/${id}`);
  }

}
